<div id="content">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title d-flex align-items-center justify-content-between flex-wrap mb-3">
          <h1>{{ page_title }}</h1>

          @if (is_admin_or_rrhh()) {
            <button mat-flat-button color="accent" (click)="createDocument()">
              <mat-icon>add</mat-icon>
              Crear
            </button>
          }
        </div>
      </div>
    </div>

    <div class="bisual-table">
      <form class="card paginator" [formGroup]="filterForm">
        <mat-paginator
          [length]="length"
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [pageIndex]="pageIndex"
          (page)="changePage($event)"
          style="margin-right: auto"
        />

        <mat-form-field appearance="outline" class="bisual-paginator-select">
          <mat-label>Tipo documento</mat-label>
          <mat-select multiple formControlName="document_type_ids" placeholder="Todos">
            @for (opt of documentTypeOptions(); track opt.value) {
              <mat-option [value]="opt.value">
                {{ opt.label }}
                @if (!opt.related_user_can_view_document) {
                  <mat-icon class="ms-2" style="font-size: 16px">lock</mat-icon>
                }
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <input matInput type="text" formControlName="search" />
          <button matSuffix mat-icon-button aria-label="Clear">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </form>

      <div class="bisual-table-container">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">
              <div class="d-flex align-items-center type-cell">
                <span class="text-truncate" [matTooltip]="document.document_type?.name || null" matTooltipPosition="above">
                  {{ document.document_type?.name || '-' }}
                </span>
                @if (document.document_type && !document.document_type.related_user_can_view_document) {
                  <mat-icon
                    class="ms-2 flex-shrink-0"
                    matTooltip="El usuario relacionado con este documento no puede verlo. Sólo pueden verlo usuarios administradores o de RRHH."
                    style="font-size: 18px"
                  >
                    lock
                  </mat-icon>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef>Tamaño</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">{{ document.size / (1024 * 1024) | number: '1.2-2' }} MB</td>
          </ng-container>

          <ng-container matColumnDef="start_date">
            <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">
              <span>{{ document.start_date | date: 'shortDate' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="end_date">
            <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">
              <span>{{ document.end_date ? (document.end_date | date: 'shortDate') : '-' }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef>Comentario</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">
              @if (document.shouldShowTooltip) {
                <span class="fw-bold" [matTooltip]="document.comment" matTooltipPosition="above">
                  {{ document.truncatedComment }}
                </span>
              } @else {
                <span class="fw-bold">{{ document.truncatedComment }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let document; dataSource: dataSource">
              <div class="d-flex gap-2">
                <button mat-icon-button color="primary" (click)="downloadDocument(document)" matTooltip="Descargar">
                  <mat-icon>download</mat-icon>
                </button>
                @if (is_admin_or_rrhh() && !isViewingOwnDocuments()) {
                  <button mat-icon-button color="accent" (click)="editDocument(document)" matTooltip="Editar">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" (click)="deleteDocument(document)" matTooltip="Eliminar">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
